// File: components/eventsSectionsComponents/TransformativeEventsSection.jsx

import React from "react";
import "./TransformativeEventsSection.css";

import {
  Presentation,
  Mic2,
  PanelsTopLeft,
  Users
} from "lucide-react";

import conferenceBg from "../../Assets/images/uniwordconference.jpeg";

export default function TransformativeEventsSection() {

  const eventPrograms = [
    {
      icon: <Presentation size={42} />,
      title: "Workshops & Retreats",
      description:
        "Engage in transformative workshops and immersive retreats focused on personal and professional growth."
    },

    {
      icon: <Mic2 size={42} />,
      title: "Conferences & Keynotes",
      description:
        "Attend, host, or speak at inspiring conferences and keynotes that bring innovative ideas to life."
    },

    {
      icon: <PanelsTopLeft size={42} />,
      title: "Literary Fairs & Expos",
      description:
        "Participate in literary fairs and expos where leaders share insights, stories, and strategies."
    },

    {
      icon: <Users size={42} />,
      title: "Masterminds & Seminars",
      description:
        "Join intimate masterminds and seminars where visionary leaders collaborate and exchange ideas."
    }
  ];

  return (

    <section
      className="transformative-events-section"
      style={{
        backgroundImage: `
          linear-gradient(
            rgba(15, 10, 8, 0.82),
            rgba(15, 10, 8, 0.88)
          ),
          url(${conferenceBg})
        `
      }}
    >

      <div className="transformative-events-container">

        {/* Header */}
        <div className="transformative-events-header">

          <span className="transformative-events-subtitle">
            Premium Leadership Experiences
          </span>

          <h2>
            Host and Participate in Transformative Events
          </h2>

          <p>
            Curated experiences designed to inspire visionary thinking,
            executive growth, meaningful collaboration, and transformational leadership.
          </p>

        </div>

        {/* Cards */}
        <div className="transformative-events-grid">

          {eventPrograms.map((item, index) => (

            <div
              className="transformative-events-card"
              key={index}
            >

              <div className="transformative-events-icon">
                {item.icon}
              </div>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.description}
              </p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
}